let lastReportedPath = null

function defer(callback) {
  if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(() => callback(), { timeout: 1500 })
    return
  }
  window.setTimeout(callback, 300)
}

export function reportPageView(path = window.location.pathname) {
  if (!path || path === '/admin' || path.startsWith('/api/admin/')) return
  if (lastReportedPath === path) return
  lastReportedPath = path

  defer(() => {
    fetch('/api/admin/pageview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path }),
      keepalive: true,
    }).catch(() => {
      // 离线文档或本地后端未启动时静默忽略
    })
  })
}
